import { maskedEmail } from './maskedEmail';
import { emailContact } from './contacts';

interface Invitation {
    contactId: string;
    email: string;
    appId: string;
    locale?: string;
}

export const invitation: Invitation = {
    contactId: emailContact.contactId,
    email: maskedEmail,
    appId: '3434',
    locale: 'rv'
};

export const invitationWithoutLocale: Invitation = {
    contactId: emailContact.contactId,
    email: maskedEmail,
    appId: '3434'
};
